import React from 'react';
import _ from 'lodash';
import { styled } from '@mui/material/styles';
import { Box, Portal, Backdrop, IconButton, Typography } from '@mui/material';
import { useQuery } from 'react-fetching-library';

import { useResponsive } from '../../../../services/hooks';
import Iconify from '../../../../components-core/Iconify';
import { FullScreenView } from './promotion-details/FullScreenView';
import { SimpleView } from './promotion-details/SimpleView';
import { getPromotionPredefinedFilters } from '../../../../services/request';
const RootStyle = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 1999,
  minHeight: 440,
  outline: 'none',
  display: 'flex',
  position: 'fixed',
  overflow: 'hidden',
  flexDirection: 'column',
  margin: theme.spacing(3),
  boxShadow: theme.customShadows.z20,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.paper
}));

export default function PromotionDetails(
  { isOpenCompose, onCloseCompose, parentFullScreen, data, submitCallback, allSeasons }) {
  const [fullScreen, setFullScreen] = React.useState(false);
  const isDesktop = useResponsive('up', 'sm');

  const [treeObjects, setTreeObjects] = React.useState({});
  const [seasonId, setSeasonId] = React.useState(data ? data.season : allSeasons[allSeasons.length - 1].value);
  const { error, payload, loading } = useQuery(getPromotionPredefinedFilters(seasonId, 'Pokaż promocję w wybranych kategoriach'));

  React.useEffect(() => {
    if (!error && !loading) {
      setTreeObjects(payload);
    }
  }, [seasonId, loading]);

  const seasonChangeCallback = id => {
    setSeasonId(id);
  };

  React.useEffect(() => {
    if (!_.isNil(data) && data.season !== seasonId) {
      setSeasonId(data.season);
    }
  }, [data]);

  React.useEffect(() => {
    setFullScreen(parentFullScreen);
  }, [parentFullScreen]);

  const handleExitFullScreen = () => {
    setFullScreen(false);
  };

  const handleEnterFullScreen = () => {
    setFullScreen(true);
  };

  const handleClose = () => {
    onCloseCompose();
    setFullScreen(false);
  };

  if (!isOpenCompose) {
    return null;
  }

  return (
    <Portal>
      <Backdrop open={fullScreen || !isDesktop} sx={{ zIndex: 1998 }} />
      <RootStyle
        sx={{
          ...(fullScreen && {
            top: 0,
            left: 0,
            zIndex: 1999,
            margin: 'auto',
            width: {
              xs: 'calc(100% - 24px)',
              md: 'calc(100% - 20px)'
            },
            height: {
              xs: 'calc(100% - 24px)',
              md: 'calc(100% - 10px)'
            }
          })
        }}
      >
        <Box
          sx={{
            pl: 3,
            pr: 1,
            height: 60,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Typography variant="h6">{data ? data.name : ''}</Typography>
          <Box sx={{ flexGrow: 1 }} />
          {data ? <IconButton onClick={fullScreen ? handleExitFullScreen : handleEnterFullScreen}>
            <Iconify icon={fullScreen ? 'eva:collapse-fill' : 'eva:expand-fill'} width={20} height={20} />
          </IconButton> : null}
          <IconButton onClick={handleClose}>
            <Iconify icon={'eva:close-fill'} width={20} height={20} />
          </IconButton>
        </Box>
        { fullScreen
          ? <FullScreenView
            data={data}
            submitCallback={submitCallback}
            handleClose={handleClose}
            allSeasons={allSeasons}
            seasonChangeCallback={seasonChangeCallback}
            treeObjects={treeObjects}
          />
          : <SimpleView data={data} treeObjects={treeObjects} />
        }
      </RootStyle>
    </Portal>
  );
}
